module.exports = __webpack_public_path__ + "static/img/14.797af4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/companyLogo/14.png
// module id = saQf
// module chunks = 1